<template>
  <div
    :class="linkClasses"
    @click="click"
  >
    <el-link v-bind="$attrs">
      <slot />
    </el-link>
  </div>
</template>
<script>
export default {
  name: 'RtLink',
  props: {
    // 是否显示悬浮背景
    hoverBackground: Boolean
  },
  computed: {
    linkClasses () {
      let classList = ['rt-link'];
      if (this.hoverBackground) {
        classList.push('rt-link-hover-background');
      }
      return classList;
    }
  },
  methods: {
    click () {
      this.$emit('click');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLink.vue?b8d12eb6